@layer refine.base {
  :host {
    --_bg: var(--accordion-bg);
    --_border-color: var(--accordion-border-color);

    display: flex;
    flex-direction: column;
    gap: var(--size-2);
    width: 100%;
    background: var(--_bg);
  }

  ::slotted(ore-accordion-item) {
    width: 100%;
  }
}

@layer refine.variants {
  /* ========================================
       Visual Variants
       ======================================== */

  /* Bordered variant */
  :host([variant='bordered']) {
    gap: var(--size-2);
  }

  /* Text variant - borderless with dividers */
  :host([variant='text']) {
    gap: 0;
  }

  :host([variant='text']) ::slotted(ore-accordion-item:not(:last-child)) {
    border-bottom: 1px solid var(--accordion-divider-color, var(--color-contrast-200));
  }

  /* Contained variants - grouped appearance */
  :host([variant='solid']),
  :host([variant='flat']),
  :host([variant='glass']),
  :host([variant='frost']) {
    gap: 0;
    padding: var(--size-2);
    border-radius: var(--rounded-lg);
  }

  /* Solid variant (default) */
  :host([variant='solid']) {
    --_bg: var(--accordion-bg, var(--color-contrast-50));
    --_border-color: var(--accordion-border-color, var(--color-contrast-200));

    border: var(--border) solid var(--_border-color);
    box-shadow: var(--accordion-shadow, var(--shadow-xs));
  }

  /* Flat variant */
  :host([variant='flat']) {
    --_bg: var(--accordion-bg, var(--color-contrast-100));
    --_border-color: var(--accordion-border-color, var(--color-contrast-200));

    border: var(--border) solid var(--_border-color);
    box-shadow: var(--accordion-shadow, var(--inset-shadow-xs));
  }

  /* Glass & Frost - Shared styles */
  :host([variant='glass']),
  :host([variant='frost']) {
    box-shadow: var(--accordion-shadow, var(--shadow-md), var(--inset-shadow-xs));
    backdrop-filter: blur(var(--blur-lg)) saturate(180%) brightness(1.05);
  }

  /* Glass variant - translucent with blur */
  :host([variant='glass']) {
    --_bg: var(--accordion-bg, color-mix(in oklch, var(--color-secondary) 30%, var(--color-contrast) 10%));
  }

  /* Frost variant - canvas-based transparency */
  :host([variant='frost']) {
    --_bg: var(--accordion-bg, color-mix(in oklch, var(--color-canvas) 55%, transparent));
  }

  /* Nested item border radius for glass and frost variants */
  :host(:is([variant='glass'], [variant='frost'])) ::slotted(ore-accordion-item) {
    border-radius: 0;
  }

  :host(:is([variant='glass'], [variant='frost'])) ::slotted(ore-accordion-item:first-child) {
    border-radius: var(--rounded-lg) var(--rounded-lg) 0 0;
  }

  :host(:is([variant='glass'], [variant='frost'])) ::slotted(ore-accordion-item:last-child) {
    border-radius: 0 0 var(--rounded-lg) var(--rounded-lg);
  }

  :host(:is([variant='glass'], [variant='frost'])) ::slotted(ore-accordion-item:only-child) {
    border-radius: var(--rounded-lg);
  }
}
